(() => {
  const drawer=document.getElementById('CoppiceCart');
  if(!drawer||!drawer.showModal)return;
  const root=window.Shopify?.routes?.root||'/';
  const gifts=[{id:Number(drawer.dataset.kitchenVariant),minimum:3},{id:Number(drawer.dataset.movementVariant),minimum:5}];
  let busy=false,opener=null;
  const error=drawer.querySelector('[data-cart-error]');
  const isGift=item=>gifts.some(gift=>gift.id===item.variant_id)&&(item.properties?._coppice_gift==='first-order'||item.final_line_price===0);
  async function request(path,body){
    const response=await fetch(root+path+(path.includes('?')?'&':'?')+'appstle=true',{method:body?'POST':'GET',headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{}),cache:'no-store'});
    const result=await response.json();
    if(!response.ok)throw new Error(result.description||result.message||'Your cart could not be updated. Please try again.');
    return result;
  }
  function setBusy(value){busy=value;drawer.setAttribute('aria-busy',String(value));drawer.querySelectorAll('[data-cart-step],[data-cart-remove],[name="checkout"]').forEach(button=>button.disabled=value);}
  function report(reason){error.textContent=reason.message||'Please try again.';error.hidden=false;}
  function open(trigger){opener=trigger||document.activeElement;if(!drawer.open){drawer.showModal();document.body.classList.add('cc-cart-open');}}
  async function render(){
    const response=await fetch(root+'?sections=coppice-cart-drawer',{headers:{Accept:'application/json'},cache:'no-store'});
    if(!response.ok)throw new Error('Please refresh to see your updated cart.');
    const sections=await response.json();
    const page=new DOMParser().parseFromString(sections['coppice-cart-drawer']||'','text/html');
    const content=page.querySelector('[data-cart-content]');
    if(!content)throw new Error('Please refresh to see your updated cart.');
    drawer.querySelector('[data-cart-content]').replaceWith(content);
    const count=content.dataset.count;
    document.querySelectorAll('[data-cart-count],.cart-count').forEach(node=>node.textContent=count);
    document.querySelectorAll('[data-cart-open] .sr-only').forEach(node=>node.textContent=count+' items');
    drawer.querySelector('[data-cart-status]').textContent='Cart updated. '+count+' items.';
  }
  // Gift lines never have a selling plan. Keep them at one per qualifying first order.
  async function syncGifts(cart,knownGiftIds=[]){
    const bottles=cart.items.filter(item=>item.handle==='natto'&&item.selling_plan_allocation).reduce((total,item)=>total+item.quantity,0);
    const updates={},additions=[];
    for(const gift of gifts){
      const lines=cart.items.filter(item=>item.variant_id===gift.id&&(isGift(item)||knownGiftIds.includes(item.variant_id)));
      const wanted=bottles>=gift.minimum;
      lines.forEach((item,index)=>{const quantity=wanted&&index===0?1:0;if(quantity!==item.quantity)updates[item.key]=quantity;});
      if(wanted&&!lines.length)additions.push({id:gift.id,quantity:1,properties:{_coppice_gift:'first-order'}});
    }
    if(Object.keys(updates).length)await request('cart/update.js',{updates});
    if(additions.length)await request('cart/add.js',{items:additions});
  }
  async function add(items,trigger){
    if(busy)throw new Error('Your cart is updating. Please try again in a moment.');
    setBusy(true);error.hidden=true;
    try{
      const before=await request('cart.js');
      const known=before.items.filter(item=>isGift(item)&&!item.properties?._coppice_gift).map(item=>item.variant_id);
      const requested=items.filter(item=>!gifts.some(gift=>gift.id===Number(item.id))||!item._bundleGift).map(item=>{const clean={...item};delete clean._bundleGift;return clean;});
      await request('cart/add.js',{items:requested});
      const containsNatto=items.some(item=>item.selling_plan);
      if(containsNatto)await syncGifts(await request('cart.js'),known);
      await render();open(trigger);
    }finally{setBusy(false);}
  }
  async function change(row,quantity,focusSelector){
    if(busy)return;
    setBusy(true);error.hidden=true;
    const variant=row.dataset.cartVariant;
    try{
      const before=await request('cart.js');
      const item=before.items.find(line=>line.key===row.dataset.cartKey);
      if(!item)throw new Error('Your cart has changed. Please reopen it and try again.');
      const known=before.items.filter(line=>isGift(line)&&!line.properties?._coppice_gift).map(line=>line.variant_id);
      let cart;
      if(item.handle==='natto'){
        const group=before.items.filter(line=>line.variant_id===item.variant_id&&line.selling_plan_allocation?.selling_plan.id===item.selling_plan_allocation?.selling_plan.id);
        const updates={};group.forEach((line,index)=>updates[line.key]=index===0?quantity:0);
        cart=await request('cart/update.js',{updates});
      }else cart=await request('cart/change.js',{id:item.key,quantity});
      if(item.handle==='natto')await syncGifts(cart,known);
      await render();
      drawer.querySelector(`[data-cart-variant="${variant}"] ${focusSelector}`)?.focus();
    }catch(reason){report(reason);await render().catch(()=>{});}finally{setBusy(false);}
  }
  document.addEventListener('click',async event=>{
    const link=event.target.closest('a[href]');
    if(link&&!event.defaultPrevented&&!event.metaKey&&!event.ctrlKey&&!event.shiftKey&&!event.altKey&&event.button===0&&link.target!=='_blank'){
      const url=new URL(link.href,location.href);
      if(url.origin===location.origin&&url.pathname.replace(/\/$/,'')===(root+'cart').replace(/\/$/,'')&&!url.search){
        event.preventDefault();if(busy)return;open(link);setBusy(true);error.hidden=true;
        try{await render();}catch(reason){report(reason);}finally{setBusy(false);}return;
      }
    }
    if(event.target.closest('[data-cart-close]'))drawer.close();
    if(event.target===drawer){const rect=drawer.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)drawer.close();}
    const control=event.target.closest('[data-cart-step],[data-cart-remove]');
    if(control&&drawer.contains(control)){
      const row=control.closest('[data-cart-key]');
      const quantity=control.hasAttribute('data-cart-remove')?0:Math.max(0,Number(row.querySelector('[data-cart-quantity]').dataset.cartQuantity)+Number(control.dataset.cartStep));
      await change(row,quantity,control.hasAttribute('data-cart-remove')?'[data-cart-remove]':`[data-cart-step="${control.dataset.cartStep}"]`);
    }
  });
  drawer.addEventListener('close',()=>{document.body.classList.remove('cc-cart-open');if(opener?.isConnected)opener.focus();});
  document.addEventListener('submit',async event=>{
    const form=event.target;
    if(form.matches('.p-subscription-form')||new URL(form.action,location.href).pathname!==(root+'cart/add'))return;
    event.preventDefault();
    const button=form.querySelector('[type="submit"]'),label=button?.textContent;
    const data=new FormData(form),id=data.get('id');
    if(!id)return;
    if(button){button.disabled=true;button.textContent='Adding…';}
    try{const item={id,quantity:Number(data.get('quantity')||1)};if(data.get('selling_plan'))item.selling_plan=data.get('selling_plan');await add([item],button);}catch(reason){open(button);report(reason);}finally{if(button){button.disabled=false;button.textContent=label;}}
  });
  window.CoppiceCart={add};
})();
